var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 13V8.5C21.25 7.17392 20.7232 5.90215 19.7855 4.96447C18.8479 4.02678 17.5761 3.5 16.25 3.5H7.75C6.42392 3.5 5.15215 4.02678 4.21447 4.96447C3.27678 5.90215 2.75 7.17392 2.75 8.5V15.5C2.75 16.1566 2.87933 16.8068 3.1306 17.4134C3.38188 18.02 3.75017 18.5712 4.21447 19.0355C5.15215 19.9732 6.42392 20.5 7.75 20.5H14.01",
    stroke: "#E2AE03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00977 16.9996L5.74977 13.7996C6.10961 13.4423 6.58188 13.2202 7.08665 13.171C7.59141 13.1218 8.09768 13.2485 8.51977 13.5296C8.94185 13.8108 9.44812 13.9375 9.95289 13.8883C10.4577 13.8391 10.9299 13.617 11.2898 13.2596L13.6198 10.9296C14.2893 10.2579 15.1757 9.84585 16.1208 9.76708C17.0659 9.68832 18.0083 9.94795 18.7798 10.4996L21.2498 12.4096M8.00977 10.1696C8.22776 10.1683 8.44336 10.1241 8.64426 10.0395C8.84516 9.95482 9.02742 9.83144 9.18063 9.67637C9.33385 9.52129 9.45502 9.33756 9.53723 9.13566C9.61944 8.93375 9.66108 8.71763 9.65977 8.49964C9.65845 8.28165 9.61421 8.06604 9.52958 7.86515C9.44494 7.66425 9.32157 7.48199 9.16649 7.32877C9.01142 7.17555 8.82768 7.05438 8.62578 6.97217C8.42388 6.88996 8.20776 6.84833 7.98977 6.84964C7.54951 6.85229 7.12833 7.02973 6.8189 7.34291C6.50946 7.6561 6.33711 8.07938 6.33977 8.51964C6.34242 8.9599 6.51985 9.38107 6.83304 9.69051C7.14623 9.99994 7.56951 10.1723 8.00977 10.1696Z",
    stroke: "#E2AE03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.707 15V20",
    stroke: "#E2AE03",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 17.1054L19.0331 15.1384C18.9903 15.0955 18.9395 15.0614 18.8836 15.0381C18.8276 15.0149 18.7676 15.0029 18.7071 15.0029C18.6465 15.0029 18.5865 15.0149 18.5306 15.0381C18.4746 15.0614 18.4238 15.0955 18.3811 15.1384L16.4141 17.1054",
    stroke: "#E2AE03",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e4a17929181e8b5d70276dd136b880d6.svg";
export { ForwardRef as ReactComponent };